import React from 'react';

import { GroupContext } from './context';

const GroupProvider = ({
  children,
  name,
  levelPath: levelPathProp,
  activityType: activityTypeProp,
}) => {
  const {
    getResolveName,
    levelPath = '',
    activityType,
  } = React.useContext(GroupContext);

  const path = React.useMemo(
    () => getResolveName(name),
    [getResolveName, name]
  );

  const handleGetResolveName = React.useCallback(
    (name) => (name ? `${path}.${name}` : path),
    [path]
  );

  return (
    <GroupContext.Provider
      value={{
        getResolveName: handleGetResolveName,
        levelPath: levelPathProp || levelPath,
        activityType: activityTypeProp || activityType,
      }}
    >
      {children}
    </GroupContext.Provider>
  );
};

export const GroupActivityType = ({ children, type }) => {
  return (
    <GroupProvider name={`activityTypes.${type}`} activityType={type}>
      {children}
    </GroupProvider>
  );
};

export const GroupLevelProvider = ({ children, levelPath }) => {
  return (
    <GroupProvider name={levelPath} levelPath={levelPath}>
      {children}
    </GroupProvider>
  );
};

export const GroupSubNodeProvider = ({ children, nodeIndex }) => {
  const { levelPath } = React.useContext(GroupContext);
  const name = `nodes.[${nodeIndex}]`;

  return (
    <GroupProvider
      name={name}
      levelPath={levelPath ? `${levelPath}.${name}` : name}
    >
      {children}
    </GroupProvider>
  );
};

export const GroupMetricsProvider = ({ children }) => {
  return <GroupProvider name={'metrics'}>{children}</GroupProvider>;
};

export const GroupCMetricsProvider = ({ children }) => {
  return <GroupProvider name={'cMetrics'}>{children}</GroupProvider>;
};

export * from './hooks';
